import { useEffect, useState } from 'react';
import { ensureSminexClubClientsLoaded, getClients, getStatus, subscribe } from './store';
import { SminexClubClientsWsStatus, SminexClubWsClient } from './types';

interface UseSminexClubClientsByEventOptions {
  eventId?: number;
  requestIfEmpty?: boolean;
}

export const useSminexClubClientsByEvent = (options: UseSminexClubClientsByEventOptions = {}) => {
  const { eventId = 0, requestIfEmpty = false } = options;
  const [clients, setClients] = useState<SminexClubWsClient[]>(getClients);
  const [status, setStatus] = useState<SminexClubClientsWsStatus>(getStatus);

  useEffect(() => {
    return subscribe((state) => {
      setClients(state.clients);
      setStatus(state.status);
    });
  }, []);

  useEffect(() => {
    if (!requestIfEmpty || !eventId) return;

    if (status === 'ready' || status === 'connecting') return;

    ensureSminexClubClientsLoaded({
      eventId,
      force: status === 'error',
    });
  }, [requestIfEmpty, eventId, status]);

  const isLoading = requestIfEmpty && status !== 'ready' && status !== 'error';

  const refetch = () => {
    if (!eventId) return;
    ensureSminexClubClientsLoaded({ eventId, force: true });
  };

  return { clients, status, isLoading, refetch };
};
